import FilterSearchBox from "./FilterSearchBox";
export default FilterSearchBox;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FilterSearchBox/index.tsx